import {DoccliService} from '../../../../providers/DoccliService.js';
const doccliService = new DoccliService();

export default {
    name: "RecapScanWarning",
     data () {
    return {
      resultCheckScan:null,        
      loading:false,
      token:null,
      callbackUrl:null,
      callbackLibelle:null,
      goback:null,      
      countValue:10,
      countdownTimerId:null

    }
  },
  mounted: function () {
    if(this.$root.token)
        this.poursuivre();
    else{
      if(this.$globalService.getSessionSouscription().offreChoisie.type == 'MOB')
          this.goback = "/souscription/offresmobile/choixoffreoption";
        else
          this.goback = "/souscription/offresbox/eligibilite/choixoffreoption";
    }

    
  
  },
  beforeMount: function () {
    this.token = this.$root.token;
    this.callbackUrl = this.$root.callbackUrl;
    this.callbackLibelle = this.$root.callbackLibelle;
    this.showWarningScan();
  },
  callback:function(){      
    this.$root.logoutToken(); 
    if(this.callbackUrl)
      window.location.href=this.callbackUrl;      
  },

  methods: {
    
    poursuivre: function () {
      //console.log( this.countValue);
      this.countdownTimerId = setTimeout(() => {
        
        if (this.countValue > 0) {
          this.countValue -= 1
          if (this.countValue === 0) {        
            this.countdownTimerId = null,
            this.gotoRecapOK();
          } else {
            this.poursuivre()
          }
        }
      }, 1000)

    },
    gotoContactInfo(){
      if(this.$globalService.getSessionSouscription().offreChoisie.type == 'MOB')
        this.$router.push({name: 'ContactMobile'});
      else
        this.$router.push({name: 'Contact'});
    },
    showWarningScan: function(){
      this.$root.progress = true;
       //récuperation dans la session
       var sessionSouscription = this.$globalService.getSessionSouscription();
       if(sessionSouscription != null && sessionSouscription.resultCheckScan){
         this.resultCheckScan = sessionSouscription.resultCheckScan
         this.$root.progress = false;
       }else{
        this.$root.progress = false;
        this.$dialog.error({
          text: this.$root.errorMessage,
          title: 'Erreur',
          persistent: false,
          actions: {
            false: 'Fermer'
          }
        })
       }
      
    },
    gotoRecapOK: function(){
      if(this.$root.token)
        this.$router.push({name: 'RecapScanOkForToken'});
      else
        this.$router.push({name: 'RecapScanOk'});
        
    },
    scanDocument: function(){
              
      if (this.countdownTimerId) {
        clearTimeout(this.countdownTimerId)
        this.countdownTimerId = null
      }
      this.loading = true;
      var sessionSouscription = this.$globalService.getSessionSouscription();
      if(sessionSouscription == null || !sessionSouscription.doccli_id){
        this.loading = false;
        this.$dialog.error({
          text: "Une erreur s'est produite",
          title: 'Erreur',
          persistent: false,
          actions: {
            false: 'Fermer'
          }
        })
      }
      doccliService.getsdkwebscanbydoccli(sessionSouscription.doccli_id).then(res => { 
          this.loading = false;
          if(res){
            if (res.err !='error') {
              this.$globalService.setSessionSouscription('sdkwebScan',res.params.sdkwebScan);
              this.$router.push({name: 'ProgressScan'});
              
                        
            }else{
              this.$dialog.error({
                text: res.err_msg,
                title: 'Erreur',
                persistent: false,
                actions: {
                  false: 'Fermer'
                }
              })
            
            }
          }
        }).catch(error=>{
    
              this.loading = false;
              this.$dialog.notify.error(this.$root.errorMessage, {
                        position: 'bottom-right',
                        timeout: 5000
                      })
            return error;
          })
      //this.$router.push({path: '/souscription/scandocuments'});
    }
  }
}